/**
 * Utilities for persistent storage using localStorage
 */

export const STORAGE_KEYS = {
    FOLDERS: 'folders',
    SELECTED_COLLECTION_ID: 'selectedCollectionId',
    LEGACY_LISTS: 'lists',
    LEGACY_SELECTED_LIST_ID: 'selectedListId',
    TRASH: 'trash',
    SECRET_COLLECTION_PIN: 'secretCollectionPin',
} as const;

/**
 * Safely saves data to localStorage
 * @param key - The key to save under
 * @param data - The data to save (will be stringified)
 */
export const saveToStorage = (key: string, data: unknown): void => {
    try {
        localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
        console.error(`Error saving to storage for key "${key}":`, error);
    }
};

/**
 * Safely loads data from localStorage
 * @param key - The key to load
 * @param defaultValue - Default value if key is not found
 * @returns The parsed data or defaultValue
 */
export const loadFromStorage = <T = unknown>(key: string, defaultValue: T | null = null): T | null => {
    try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
        console.error(`Error loading from storage for key "${key}":`, error);
        return defaultValue;
    }
};

/**
 * Removes an item from localStorage
 * @param key - The key to remove
 */
export const removeFromStorage = (key: string): void => {
    localStorage.removeItem(key);
};
